import React from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../Context/auth';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import MovimentacaoForm from '../Components/MovimentacaoForm/MovimentacaoForm';
import '../Marcas/Marcas.css'; // Importa estilos padronizados

function NovaMovimentacao() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();

    // Verifica permissão de cadastro
    React.useEffect(() => {
        if (appUserData && !appUserData['cadastrar_movimentacoes']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para cadastrar movimentações.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home'); // Volta para a home
            });
        }
    }, [appUserData, navigate]);

    const handleSave = async (formData) => {
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/movimentacoes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao criar movimentação');
            }

            Swal.fire('Sucesso!', 'Movimentação de estoque criada com sucesso!', 'success');
            navigate('/app/movimentacoes');
        } catch (error) {
            Swal.fire('Erro', error.message, 'error');
        }
    };

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/movimentacoes')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Nova <span className="highlight">Movimentação</span>
                        </h1>
                    </div>
                </div>
                <div className="marcas-content">
                    <MovimentacaoForm onSubmit={handleSave} />
                </div>
            </div>
        </div>
    );
}

export default NovaMovimentacao;